import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../../API";



export const getAllPromoitonForShopAction = createAsyncThunk(

    "PromotionForShop/GetAllPromotionForShop",
    async (data) => {
      return apiCall("supplierpromotion", "GET",data, false)
        .then((response) => {
          // console.log("response",response)
          if (response.status === 200) {
            if (!response.data.hasError) {
            
              return {
                ...response.data,
              }
            } else {
              console.log("response error", response.data.message);
              return Promise.reject({
                ...response.data.message,
              });
            }
          }
        })
        .catch((error) => {
          return Promise.reject({
            ...error,
          });
        });
    }
  );